import Big from "big.js";

export class StringFormatExtention {
    private static readonly commaRegex: RegExp = new RegExp(/\B(?=(\d{3})+(?!\d))/g);

    public static formatWithComma(value: number | string | Big): string {
        const splitResult = value.toString().split(".");
        const firstPartFormatted = splitResult[0].replace(StringFormatExtention.commaRegex, ',');
        return splitResult.length > 1 ? `${firstPartFormatted}.${splitResult[1]}` : firstPartFormatted;
    }

    public static emailFormatWithStars(email: string): string {
        const splitResult = email.split("@");
        const firstPart = splitResult[0].length >= 2 ? splitResult[0].slice(0, 2) : splitResult[0];
        return `${firstPart}****@${splitResult[1]}`;
    }

    public static abbreviatedFormat(value: number): string {
        if (value >= 1000000) {
            return (value / 1000000).toFixed(0) + "m";
        } else {
            if (value >= 1000) {
                return (Math.floor(value / 1000)).toFixed(0) + "k";
            } else {
                return value.toString();
            }
        }
    }

    public static tokensFormat(value: string): string {
        const result = new Big(value);
        if (result.lt("1.0")) {
            const formattedString = result.toFixed(4);
            return formattedString.replace(/\.?0*$/, "");
        }
        if (result.lt("1000")) {
            return result.toPrecision(5).replace(/\.?0*$/, "");
        }
        if (result.lt("100000")) {
            return this.formatWithComma(result.toPrecision(5));
        }
        if (result.lt("1000000")) {
            return this.formatWithComma(result.toPrecision(6));
        }
        return result.toPrecision(8);
    }

    public static expiresFromHoursFormat(hours: number): string {
        const minutes = hours * 60;
        const days = Math.floor(hours / 24);
        if (days >= 1) {
            return `${days} DAYS`;
        }
        if (hours >= 1) {
            return `${hours} HOURS`;
        }
        return `${minutes} MINUTES`;
    }

    public static expiresFromMsFormat(ms: number): string {
        const minutes = Math.floor(ms / 60000);
        const hours = Math.floor(minutes / 60)
        const days = Math.floor(hours / 24);
        if (days >= 1) {
            return `${days} DAYS`;
        }
        if (hours >= 1) {
            return `${hours} HOURS`;
        }
        return `${minutes} MINUTES`;
    }

    public static walletAddressFormat(walletAddress: string): string {
        if (walletAddress.length <= 9) {
            return walletAddress;
        }
        const firstPart = walletAddress.substring(0, 5);
        const lastPart = walletAddress.substring(walletAddress.length - 4);
        return `${firstPart}...${lastPart}`;
    }
}   
